<template>
  <div>
    <section class="hint">
      <p>Detta behöver du göra</p>
    </section>
    <section class="info">
      <div class="info__triangle"></div>
      <div class="info__content" v-if="value === 0">
        <img class="info__svg--crown" src="../../assets/svg/crown.svg"/>
        <p class="info__text info__text--crown"> Bra jobbat! Du har klarat av dina sparmål för att uppnå önskad pension </p>
      </div>
      <div class="info__content" v-else>
        <p class="info__text"> Du behöver öka ditt sparande med </p>
        <div class="info__value-container">
          <img class="info__svg" src="../../assets/svg/piggy-bank.svg"/>
          <p class="info__value"> {{ value }} </p>
        </div>
        <p class="info__currency">KR/MÅN</p>
        <p class="info__total">För att spara ihop till <span>{{ total }} kr</span></p>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'TargetResult',
  props: [ 'value', 'total' ]
}
</script>

<style lang="scss" scoped>
.hint {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 6.25rem;
  background-color: $green;

  > p {
    color: $white;
    font-weight: bold;
  }
}

.info {
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: rgba(118, 192, 77, .15);
  border-bottom-left-radius: $borderRadius;
  border-bottom-right-radius: $borderRadius;

  &__triangle {
    width: 0;
    height: 0;
    border-left: 2rem solid transparent;
    border-right: 2rem solid transparent;
    border-top: 2rem solid $green;
    align-self: center;
  }

  &__content {
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    justify-content: space-evenly;
    margin: 2rem 0;
  }

  &__text {
    font-size: 1.25rem;
    font-weight: 100;
    margin-bottom: 5px;
    text-align: center;

    &--crown {
      margin-top: 1rem;
      max-width: 80%;
      text-align: center !important;
    }
  }

  &__value-container {
    display: flex;
    align-items: center;
  }

  &__svg {
    height: 3rem;
    width: 55px;

    &--crown {
      height: 5rem;
    }
  }

  &__value {
    margin-left: 10px;
    font-size: 4rem;
    font-weight: 100;
  }

  &__currency {
    font-size: 2rem;
    font-weight: 100;
  }

  &__total {
    margin-top: 2rem;

    span {
      font-weight: bold;
    }
  }

  @include breakpoints(medium) {
    &__text {
      text-align: left;
    }
  }
}
</style>